import Phone from './phone/Phone'
import Radio from './radio/Radio'
import Select from './select/Select'
import Text from './text/Text'
import Textarea from './textarea/Textarea'

export default {
  Phone,
  Radio,
  Select,
  Text,
  Textarea,
}
